/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TagIcon16Solid = forwardRef('TagIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.185 2a2.5 2.5 0 0 0-1.935.917L.536 6.234a2 2 0 0 0 0 2.532l2.714 3.317A2.5 2.5 0 0 0 5.185 13H12.5a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 12.5 2H5.185ZM4.5 8.624a1.124 1.124 0 1 0 0-2.248 1.124 1.124 0 0 0 0 2.248Z" })));
});
